import { titles } from "../../mockData/title-mock";
import CallApi from "../../util/CallApi";

export const FETCH_TITLES = "FETCH_TITLES";
export const FETCH_TITLES_SUCCESS = "FETCH_TITLES_SUCCESS";
export const FETCH_TITLES_FAILURE = "FETCH_TITLES_FAILURE";
export const FETCH_ADDRESS_PROJECT = "FETCH_ADDRESS_PROJECT";
export const FETCH_ADDRESS_PROJECT_SUCCESS = "FETCH_ADDRESS_PROJECT_SUCCESS";
export const FETCH_ADDRESS_PROJECT_FAILURE = "FETCH_ADDRESS_PROJECT_FAILURE";
export const FETCH_PROJECT_COMPANY = "FETCH_PROJECT_COMPANY";
export const FETCH_PROJECT_COMPANY_SUCCESS = "FETCH_PROJECT_COMPANY_SUCCESS";
export const FETCH_PROJECT_COMPANY_FAILURE = "FETCH_PROJECT_COMPANY_FAILURE";

const callApi = new CallApi();
const mockup = false;

export const fetchTitles = params => dispatch => {
  dispatch({ type: FETCH_TITLES });
  if (mockup) {
    return dispatch({ type: FETCH_TITLES_SUCCESS, payload: titles });
  } else {
    return callApi
      .get("/query/titles")
      .then(data => {
        dispatch({ type: FETCH_TITLES_SUCCESS, payload: data });
      })
      .catch(error => dispatch({ type: FETCH_TITLES_FAILURE }));
  }
};

export const fetchAddressProject = params => dispatch => {
  dispatch({ type: FETCH_ADDRESS_PROJECT });
  return callApi
    .post("/query/address_delivery", params)
    .then(data => {
      dispatch({ type: FETCH_ADDRESS_PROJECT_SUCCESS, payload: data });
    })
    .catch(error => dispatch({ type: FETCH_ADDRESS_PROJECT_FAILURE }));
};

export const fetchAddressCompany = params => dispatch => {
  dispatch({ type: FETCH_PROJECT_COMPANY });
  return callApi
    .post("/query/address_company", params)
    .then(data => {
      dispatch({ type: FETCH_PROJECT_COMPANY_SUCCESS, payload: data });
    })
    .catch(error => dispatch({ type: FETCH_PROJECT_COMPANY_FAILURE }));
};
